import config from '@app/config'
import { getProfileFromCookie } from '@app/store/auth'
import { base64UrlEncode } from '@app/utils/url'

import { getDefaultUrlBase } from './profilePresentation'

const getEncodedSourceUrl = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const url = new URL(window.location.href)
  const sourceUrl = `${url.pathname}${url.search}`

  if (!sourceUrl) {
    return null
  }

  return base64UrlEncode(encodeURIComponent(sourceUrl))
}

export const getB2CProfileUrl = (pathname: string, email: string): string => {
  const base =
    config.identity.dashboardUrl ||
    config.identity.website ||
    getDefaultUrlBase()

  try {
    const profileUrl = new URL(pathname, base)
    const sourceUrl = getEncodedSourceUrl()
    const profile = getProfileFromCookie()

    if (sourceUrl) {
      profileUrl.searchParams.set('sourceUrl', sourceUrl)
    }

    if (profile?.id && profile?.code) {
      profileUrl.searchParams.set(
        'acr_values',
        `profile_id:${profile.id} code:${profile.code}`
      )
    }

    if (email) {
      profileUrl.searchParams.set('email', email)
    }

    return profileUrl.toString()
  } catch {
    return pathname
  }
}

export const getProfessionalsDashboardUrl = (culture: string): string => {
  const base =
    config.variables.dashboardLink ||
    config.identity.dashboardUrl ||
    getDefaultUrlBase()

  try {
    return new URL(`/${culture}/home`, base).toString()
  } catch {
    return '/'
  }
}
